<template>
  <b-card class="sankeyChart">
    <div v-if="!reportMode || reportMode == 'editable'">
      <b-form inline class="sankey-filters mb-3" v-if="maxDepth > 1 || vectors.length > 1">
        <label v-if="maxDepth > 1"
          >Profondità:
          <b-form-select class="sel" v-model="curDepth">
            <option v-for="i in maxDepth" :key="i">{{ i }}</option>
          </b-form-select>
        </label>
        <b-form-checkbox-group
          v-if="vectors.length > 1"
          class="filter-vectors"
          v-model="selectedVectors"
          :options="vectors"
        ></b-form-checkbox-group>
      </b-form>
    </div>
    <b-alert class="mt-4" :show="selectedVectors != null && selectedVectors.length == 0" variant="warning"
      >Selezionare almeno un vettore energetico</b-alert
    >
    <div id="sankey_basic" style="width: 100%; height: 0px"></div>
    <div :style="{ height: checkChartHeight }" style="width: 100%" :id="chartId"></div>
  </b-card>
</template>

<script>
import { makeid } from "./helpers";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { startRender, finishRender } from "../../helpers/printReady";

export default {
  name: "Sankey",
  props: ["tep", "site", "reportMode", "sankeyParameters"],
  data() {
    return {
      chart: null,
      table: null,
      maxDepth: 0,
      curDepth: 0,
      selectedVectors: null,
      chartReady: false,
      rows: 0,
      maxRows: 10000,
      allChannels: [],
      depths: {},
      chartId: undefined,
      amChartData: [],
      amChart: null,
      isSankey: true,
      services: [],
    };
  },
  created() {
    this.chartId = makeid();
    if (this.reportMode && this.sankeyParameters) {
      if (this.sankeyParameters) {
        this.curDepth = this.sankeyParameters.curDepth;
        this.selectedVectors = this.sankeyParameters.selectedVectors;
      }
    }
    this.chartReady = true;
    // this.refresh()
  },

  mounted() {
    this.refresh();
  },

  beforeDestroy() {
    this.unload();
  },

  methods: {
    refresh() {
      this.amChartData = [];

      if (!this.tep || this.tep == null) return;
      if (this.selectedVectors == null)
        this.selectedVectors = [...new Set(this.tep.map((e) => this.getVectorName(e.vector)))];

      this.allChannels = this.$store.state.user.sites
        .find((s) => s.guid == this.site)
        .channels.filter((c) => c.data_model_id == 1);

      this.rows = 0;

      this.services = this.tep
        .map((v) => v.category)
        .filter((v, index, self) => {
          return v != null && self.indexOf(v) === index;
        });

      if (this.maxDepth == 0) {
        var d = this.depths;
        var maxDepth = 0;
        function _c(tep, parentCode, level) {
          var children = _.filter(tep, (t) => t.parentCode == parentCode);
          children.forEach((e) => {
            d[e.code] = level;
            _c(tep, e.code, level + 1);
            if (level > maxDepth) maxDepth = level;
          });
        }

        _.filter(this.tep, (t) => t.parentCode == null).forEach((t) => {
          this.depths[t.code] = 1;
          _c(this.tep, t.code, 1);
        });

        this.maxDepth = maxDepth;
        this.curDepth = !this.curDepth ? this.maxDepth : this.curDepth;
      }

      this.selectedVectors.forEach((vector, i) => {
        this.services.forEach((service) => {
          let values = _.filter(this.tep, (item) => item.vectorName == vector && item.category == service).map(
            (item) => item.TEP
          );
          let value = values.reduce((value1, value2) => {
            return value1 + value2;
          }, 0);

          if (value) {
            if (this.rows++ < this.maxRows) this.amChartData.push([vector, service, value]);
            // this.table.addRow([ v, s, value, v + " → " + s + " ("+ this.$options.filters.formatDecimal(value) +")" ])
          }
        });
      });

      this.services.forEach((s, i) => {
        this.tep
          .filter((item) => {
            return item.category == s && this.selectedVectors.indexOf(item.vectorName) > -1;
          })
          .forEach((item) => {
            if (this.rows++ < this.maxRows && item.TEP > 0) {
              this.amChartData.push([s, item.name, item.TEP]);
            }
            this.addChildren(this.tep, item.code, item.name, 1);
          });
      });

      this.createAmChart();
    },
    addChildren(items, parentCode, parentName, level) {
      items
        .filter((item) => item.parentCode == parentCode)
        .forEach((child) => {
          if (this.curDepth < this.depths[child.code]) return;

          if (this.rows++ < this.maxRows && child.TEP > 0) {
            let channel = this.allChannels.find((c) => c.code == child.code);
            this.amChartData.push([parentName, child.name, child.TEP]);
            // this.table.addRow([ parentName, child.name, child.TEP, parentName + " → " + child.name + " ("+this.$options.filters.formatDecimal(child.TEP)+")" ])
          }
          this.addChildren(items, child.code, child.name, level + 1);
        });
    },
    getVectorName(item) {
      return this.$store.getters["vectors/getName"](item);
    },

    createAmChart() {
      let finalData = [];
      this.amChartData.forEach((ele) => {
        let leaf = ele[1];
        let sameLeaves = finalData.filter((l) => l.to == leaf && this.services.indexOf(leaf) < 0);
        let value = ele[2] ? ele[2] : 0;
        sameLeaves.forEach((l) => {
          // value += l.value;
        });
        finalData.push({
          from: ele[0],
          to: ele[1],
          value: value,
        });
      });

      finalData = finalData.map((d) => {
        d.value = d.value.toFixed(2);
        return d;
      });

      if (this.amchart) {
        this.amchart.dispose();
        this.amchart = undefined;
      }

      const chart = am4core.create(this.chartId, am4charts.SankeyDiagram);

      // Track async rendering for the Puppeteer print service.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      setTimeout(settleRender, 8000);

      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
      chart.interpolationDuration = 0;

      chart.data = [...finalData];
      if (!this.reportMode) {
        chart.fontSize = 13;
        let cellSize = 35;
        chart.events.on("validated", function (ev) {
          let chart = ev.target;
          let adjustHeight = chart.data.length * cellSize;
          chart.svgContainer.htmlElement.style.height = adjustHeight + "px";
        });
      } else if (this.reportMode == "editable") {
        chart.fontSize = 13;
      } else {
        chart.fontSize = 9;
      }

      chart.nodes.template.nameLabel.label.truncate = false;
      chart.nodes.template.nameLabel.label.wrap = true;
      chart.tooltip.getFillFromObject = false;
      chart.tooltip.background.fill = am4core.color("#FFFFFF");
      chart.tooltip.label.fill = am4core.color("black");

      let hoverState = chart.links.template.states.create("hover");
      hoverState.properties.fillOpacity = 0.6;

      chart.dataFields.fromName = "from";
      chart.dataFields.toName = "to";
      chart.dataFields.value = "value";
      // chart.dataFields.color = "nodeColor";
      chart.links.template.colorMode = "solid";
      // chart.links.template.colorMode = "gradient";
      chart.links.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");

      // for right-most label to fit
      chart.paddingRight = 150;
      chart.paddingTop = 20;
      chart.paddingBottom = 20;

      // make nodes draggable
      var nodeTemplate = chart.nodes.template;
      nodeTemplate.inert = true;
      nodeTemplate.showSystemTooltip = true;
      nodeTemplate.stroke = am4core.color("#fff");
      nodeTemplate.strokeWidth = 4;
      nodeTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;

      this.amchart = chart;
    },

    unload() {
      if (this.amchart) {
        this.amchart.dispose();
        this.amchart = undefined;
      }
    },
  },
  computed: {
    vectors() {
      if (!this.tep || this.tep == null) return [];

      let vectors = this.tep.map((e) => e.vector);

      // exclude vectors we don't manage
      vectors = vectors.filter((v) => ["EE", "gas", "olioc", "Diesel", "benz", "KJF", "GPL"].indexOf(v) >= 0);

      return _.uniq(vectors).map((e) => {
        return {
          text: this.getVectorName(e),
          value: this.getVectorName(e),
        };
      });
    },
    checkChartHeight() {
      if (!this.reportMode) {
        return "100%";
      } else if (this.reportMode == "editable") {
        return "100%";
      } else {
        return "100%";
      }
    },
  },
  watch: {
    tep() {
      if (this.chartReady) this.refresh();
    },
    selectedVectors(newVal, old) {
      if (old != null) {
        this.refresh();
      }
    },
    curDepth(newVal, old) {
      if (old != 0) this.refresh();
    },
  },
};
</script>
<style>
#sankey_basic text {
  font-family: "Open Sans", sans-serif;
}
.depth-icon {
  position: relative;
  top: 9px;
  margin: 0 10px;
  color: #cf5651;
}
.sankey-filters {
  width: auto;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 2px;
  display: inline-block;
  background: #f0f8ff;
}
.sankey-filters .sel {
  margin: 0 10px;
}
.sankey-filters label {
  display: inline-block;
}
.sankey-filters .filter-vectors {
  display: inline-block;
}
.apexcharts-menu-item.exportCSV {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Diagnosi/Sankey.vue